import React from 'react';
import * as yup from 'yup';
import FeeForm from "./FeeForm";

import { toast } from "react-toastify";
toast.configure();


const AddEditFee = (props) => {

    const {
        show,
        editValues,
        currency,
        modalType,
        feeList,
        setFeeList
    } = props;

    const checkBoxWarning = () => {
        toast.warning("Does this fee apply to adults, children or both? It is mandatory to select at least one.");
        return false;
    };

    const validationSchema = yup.object({
        feeType: yup.string().required("Fee type is a required field"),
        name: yup.string().required("Name of fee is a required field"),
        amount: yup.number().required("Amount is a required field").min(0, 'Must be a positive number').typeError('Must be a value of type number'),
        modality: yup.string(),
        feeApplyAdults: yup.boolean(),
        feeApplyChildren: yup.boolean().test("feeApplyChildren", "",  function(value) {
        return ["per person", "pppn"].includes(this.parent.modality)
        && !this.parent.feeApplyAdults
        && !value ? checkBoxWarning() : true
        }),
    });

    const initialValues = {
        name: editValues?.name || '',
        amount: editValues?.amount || '',
        feeType: editValues?.feeType || 'flat rate',
        modality: editValues?.modality || 'per stay',
        feeApplyAdults: editValues?.feeApplyAdults || false,
        feeApplyChildren: editValues?.feeApplyChildren || false,
    };

    const handleSubmit = (data) => {

        const feeObject = {
            name: data.name,
            feeType: data.feeType,
            amount: Number(data.amount),
            modality: data.modality,
            feeApplyAdults: Boolean(Number(data.feeApplyAdults)),
            feeApplyChildren: Boolean(Number(data.feeApplyChildren)),
        };

        if (editValues) {
            const updateFeeList = feeList;
            updateFeeList[editValues.index] = feeObject;
            setFeeList(updateFeeList);
        } else {
            setFeeList([...feeList, feeObject]);
        };

        show(false);
    };

    return (
        <FeeForm
            showFee={(e) => show(e)}
            initialValues={initialValues}
            validationSchema={validationSchema}
            handleSubmit={handleSubmit}
            currency={currency}
            modalType={modalType}
        />
    )
};

export default AddEditFee;